import { useContext } from "react";

import { formatMoney } from "../../utils/numbers";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import Modal from "../Modal/Modal";
import {
  Container,
  MainButton,
  Row,
  RowContainer,
} from "./QuotationErrorsStyles";

function QuotationErrors(props) {
  const {
    volantes,
    dateRucStatus,
    toggleModal,
    updateShowModal,
    updateShowModalClose,
    onCloseError,
  } = props;
  const [useDollars] = useContext(CurrencyContext);

  const onClose = () => {
    updateShowModal(false);
    toggleModal();
    onCloseError();
    updateShowModalClose(false);
  };

  const onConfirm = () => {
    updateShowModal(false);
    toggleModal();
    onCloseError();
    updateShowModalClose(false);
  };

  return (
    <Modal onOutsideClick={onClose}>
      <Container>
        <h1>Algunas prefacturas fallaron</h1>
        <h2>
          Los siguientes volantes tuvieron errores y no han podido ser
          prefacturados. Consúltelos nuevamente y verifique su estado.
        </h2>
        <RowContainer>
          {volantes.map((volante) => (
            <Row key={volante.id}>
              <div>
                <h2>{volante.id}</h2>
                <h3>{volante.importer}</h3>
              </div>
              <div className="price">
                {formatMoney(dateRucStatus[volante.id].amount, useDollars)}
              </div>
            </Row>
          ))}
        </RowContainer>
        <MainButton onClick={onConfirm}>Entendido</MainButton>
      </Container>
    </Modal>
  );
}

export default QuotationErrors;
